/**
 * RSVP-XR Entry Point
 *
 * Routes by pathname:
 * - `/` → Reader page (2D + XR mode)
 * - `/phone` → Phone companion (paste/import/control)
 */

import './styles/base.css';
import { inject } from '@vercel/analytics';
import { initReaderUI } from './ui/reader/readerUI';
import { initPhoneUI } from './ui/phone/phoneUI';

// Initialize Vercel Analytics
inject();

function init(): void {
  const app = document.getElementById('app');
  if (!app) {
    console.error('App container not found');
    return;
  }

  const path = window.location.pathname;

  if (path === '/phone' || path.startsWith('/phone?')) {
    initPhoneUI(app);
  } else {
    initReaderUI(app);
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
